export const hy = {
  title: 'VIIRS ակտիվ հրդեհներ',
  subtitle: '(օրական, 375 մ, գլոբալ, NASA)',
  download_data: 'https://earthdata.nasa.gov/earth-observation-data/near-real-time/firms/active-fire-data',
  learn_more: 'https://earthdata.nasa.gov/earth-observation-data/near-real-time/firms/viirs-i-band-active-fire-data',
  content: [
    {
      label: 'Գործառույթ',
      value: 'Ցուցադրում է վերջին 24 ժամվա, 48 ժամի, 72 ժամի կամ 7 օրվա հրդեհային ազդանշանի տվյալները',
    },
    {
      label: 'Բանաձեւ',
      value: '375 × 375 մետր',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Համաշխարհային',
    },
    {
      label: 'Աղբյուր',
      value: 'ՆԱՍԱ',
    },
    {
      label: 'Հաճախականություն',
      value: 'Օրական երկու անգամ',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: 'Գրեթե իրական ժամանակում',
    },
    {
      label: 'Զգուշացումներ',
      value:
        'Ոչ բոլոր հրդեհներն են հայտնաբերվում: Կան մի քանի պատճառ, թե ինչու VIIRS-ը չի հայտնաբերել որոշակի հրդեհ: Հրդեհը կարող էր սկսվել և ավարտվել արբանյակային վերգետնյա անցումների միջև։ Հրդեհը կարող էր լինել շատ փոքր կամ շատ սառը, որպեսզի հնարավոր լինի հայտնաբերել 375 մետրանոց պիքսելում: Ամպածածկույթը, թանձր ծուխը կամ ծառերի ծածկը կարող են ամբողջությամբ ծածկել կրակը:',
    },
    {
      label: 'Լիցենզիա',
      value:
        'Մենք ընդունում ենք տվյալների և պատկերների օգտագործումը LANCE FIRMS-ից, որը շահագործվում է NASA/GSFC/Երկրի գիտության տվյալների և տեղեկատվական համակարգի (ESDIS) կողմից՝ NASA/HQ-ի ֆինանսավորմամբ: \n\nNASA-ի տվյալների և տեղեկատվության քաղաքականություն',
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'VIIRS ակտիվ հրդեհների տվյալները (VNP14IMGT) հրդեհի մոնիտորինգի վերջին արտադրանքն է FIRMS-ի (Հրդեհային տեղեկատվություն ռեսուրսների կառավարման համակարգի համար), որը գրեթե իրական ժամանակում նույնականացնում է հրդեհի գլոբալ վայրերը: Տեղեկատվությունը հավաքվում է տեսանելի ինֆրակարմիր պատկերման ռադիոմետրային հավաքածուից (VIIRS) սենսորից և մշակվում հրդեհի հայտնաբերման ալգորիթմով՝ ակտիվ հրդեհները նշելու համար: Քարտեզի յուրաքանչյուր կետը ներկայացնում է 375 մետրանոց պիքսելի կենտրոնը, որը նշված է ալգորիթմի կողմից:',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'NASA FIRMS. «VIIRS Active Fires». Հասանելի է Global Forest Watch-ի միջոցով 29/01/2025-ին: www.globalforestwatch.org',
  },
};
